import React from 'react';

import InstallmentContent from '.';

import TroyPaymentCalculator from '../PaymentCalculator/index.troy';

export default props => (
  <InstallmentContent {...props} component={TroyPaymentCalculator} />
);
